import { Component, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { LoadingPanelService } from '../../shared/loading-panel/loading-panel.service';
import { DeveloperService } from '../services/developer.service';
import { ContextPropertyNamespace } from '../models/context-property-namespace';


@Component({
    selector: 'app-developer-context-properties',
    templateUrl: './developer-context-properties.component.html',
    styleUrls: ['./developer-context-properties.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class DeveloperContextPropertiesComponent implements OnInit {

    contextPropertyNamespaces = signal<ContextPropertyNamespace[]>([]);

    constructor(
        private developerService: DeveloperService,
        private loadingPanelService: LoadingPanelService) { }

    ngOnInit() {
        this.loadContextProperties().then(_ => { }).catch(_ => { });
    }

    async loadContextProperties() {
        this.loadingPanelService.showLoadingPanelDirect('Loading context properties');

        const result: ContextPropertyNamespace[] = [];
        const namespaces = await this.developerService.getContextProperties();

        const traverse = (items: ContextPropertyNamespace[]) => {
            // Sortér de aktuelle nodes før rekursion
            const sortedItems = [...items].sort((a, b) => a.Name.localeCompare(b.Name));

            for (const item of sortedItems) {
                // Sortér også Properties
                if (item.Properties?.length) {
                    item.Properties = [...item.Properties].sort((a, b) => a.Name.localeCompare(b.Name));
                }

                result.push(item);

                if (item.Childs?.length) {
                    // Rekursivt kald – og opdater samtidig item.Childs til den sorterede version
                    item.Childs = [...item.Childs].sort((a, b) => a.Name.localeCompare(b.Name));
                    traverse(item.Childs);
                }
            }
        };

        traverse(namespaces);

        this.contextPropertyNamespaces.set(result);
        this.loadingPanelService.hideLoadingPanel();
    }

    trimName(name: string): string {
        if (name.endsWith('Properties')) {
            return name.slice(0, -'Properties'.length).trim();
        }
        return name;
    }
}

